import { Card, Col, Divider, Icon, Row, Statistic, Tag,Button } from "antd";
import React from "react";
import { Link } from "react-router-dom";
export function LeftCol({
    loading,
    profiledata,
    showEdit
}) {
    return <Col lg={7} md={24}>
        <Card bordered={false} style={{
            marginBottom: 24
        }} loading={loading}>
            <div>
                <div className={"avatarHolder"}>
                    <img alt="" src="https://gw.alipayobjects.com/zos/antfincdn/XAosXuNZyF/BiazfanxmamNRoxxVxka.png" />
                    <div className={"name"}> {profiledata.fullName ? profiledata.fullName : 'NA'}</div>
                    <div>
                    <Tag style={{marginTop:5}} color="#2db7f5"> <Icon type="bank" /> { profiledata.campus ? profiledata.campus : 'NA'}</Tag> {" "}
                        <Tag style={{marginTop:5}} color="#2db7f5"> {profiledata.role ? profiledata.role : 'NA'}</Tag> {" "}  <Tag style={{marginTop:5}} color="rgb(206, 96, 157)"> {profiledata.rollnumber ? profiledata.rollnumber : profiledata.designation && profiledata.designation}</Tag>
                    </div>
                    <div style={{marginTop:6}}>
                        {" "}
                        <Icon type="mail" /> &nbsp; {profiledata.email ? profiledata.email : 'NA'}
                    </div>
                    <div>
                    {" "}
                    <Icon type="user" /> &nbsp;
                        {profiledata.gender ? profiledata.gender.toUpperCase() : 'NA'}
                    </div>
                    <div style={{marginTop:6}}>
                    {" "}
                    <Icon type="clock-circle" /> &nbsp; Profile last updated on : &nbsp;
                   
                        {profiledata.profileLastUpdatedOn ? profiledata.profileLastUpdatedOn.toDate().toString() : 'NA'}
                    </div>
                </div>
                <Divider dashed />
                <div style={{
                    marginTop: 10
                }}>
                    {profiledata.technicalSkillsArray ? profiledata.technicalSkillsArray.map(tag => {
                        let color = tag.length > 4 ? "geekblue" : "green";

                        if (tag === "C") {
                            color = "blue";
                        } else if (tag === "C-Sharp") {
                            tag = "C#";
                        } else if (tag === "C-Plus-Plus") {
                            tag = "C++";
                        }

                        return <Tag color={color} key={tag} style={{
                            marginBottom: 5
                        }}>
                            {tag.toUpperCase()}
                        </Tag>;
                    }) :  'No Skills listed'}{" "}
                </div>
                <Divider style={{
                    marginTop: 16
                }} dashed />

                <Row gutter={36}>
                    <Card style={{
                        background: "#e69f35"
                    }} bordered={false}>
                        <Statistic prefix={<Icon type="sketch" />} title="Weissman score" value={"NA"} />
                    </Card>
                </Row>
                {showEdit ? <> <Divider style={{
                    marginTop: 16
                }} dashed />

                <Row gutter={36}>
                <Link to="/home/overview"> <Button  type="primary" size="large" block >Edit Profile</Button></Link>
                </Row></> : null}
               
            </div>

        </Card>
    </Col>;
}
